// @flow

import { PlaceholderListContainer } from 'src/Domain/Placeholder/PlaceholderListContainer';

import { SuggestPlaceholderRow } from 'src/Domain/Placeholder/SuggestPlaceholderRow';

import styles from './PlaceholderList.scss';

type Props = {
  count: number,
};

export default function PlaceholderList({ count }: Props): React.MixedElement {
  return (
    <PlaceholderListContainer className={styles.root}>
      {Array(count)
        .fill('placeholder')
        .map((item, idx) => (
          <SuggestPlaceholderRow
            key={`suggestion-placeholder-${idx}`} // eslint-disable-line react/no-array-index-key
          />
        ))}
    </PlaceholderListContainer>
  );
}
